import { useContext } from 'react'

import { AnalyticsContext } from '@/core/analytics'

export const useVerticalProduct = () => {
  const { verticalProduct } = useContext(AnalyticsContext)
  return verticalProduct
}
